import React, {useState, useEffect} from 'react';
import db from '../database'; // Import the PouchDB instance from your db.js file
import { useNavigate } from 'react-router-dom';
import {useParams} from 'react-router-dom';
import { Box, Typography, Link, Card, CardContent, Badge, Stack, Button } from '@mui/material';

const MemeDetail = () => {
    const [meme, setMeme] = useState([]);
    const [img, setImg] = useState();
    const {id, movieId} = useParams();
    const navigate = useNavigate();
    const getDoc = async (item) => {
        const doc = await db.get(item)
        console.log(doc)
        const _img = await  db.getAttachment(doc._id, 'image')
        setMeme(doc)
        setImg(_img)
    }
    useEffect(() => {
        if (id) {
            getDoc(id)
        }
    }, [id])

    return (
        <Card>
            <CardContent >
                <Stack spacing={2} sx={{ height:'100vh'}}>
                    {img && (<img src={URL.createObjectURL(img)} style={{maxHeight: '50%', width: 'auto', objectFit: 'contain' }}/>)}
                    <Typography>Title : {meme?.title}</Typography>
                    <Typography>Language : {meme?.language}</Typography>
                    <Typography>Movie : {meme?.movie}</Typography>
                    <Typography>Context : {meme?.context}</Typography>
                    <Typography>Tags : {meme?.tags?.join(",")}</Typography>
                    <Typography>Actors : {meme?.actors?.join(",")}</Typography>
                    <Typography>Characters : {meme?.characters?.join(",")}</Typography>
                    <Button onClick={()=>{navigate(`/movie/${movieId}`)}}variant="contained">Back</Button>
            
                </Stack>
            </CardContent>
        </Card>
    )

}

export default MemeDetail
